import { useServerConfig } from 'hpacademy-data-authentication';

const getFullUrlPath = (basepath: string, relativePath: string) =>
  `${basepath.replace(/\/$/, '')}/${relativePath.replace(/^\//, '')}`;

export const useResolveImagePath = (src: string | undefined, defaultUrl?: string) => {
  const data = useServerConfig();
  const configuration = {
    storagePrefix: data.mediaStorage.url,
  };

  if (!src) {
    return defaultUrl;
  }

  if (!configuration?.storagePrefix) {
    return src;
  }

  const needsPrefix =
    typeof src === 'string' && !src.startsWith('http') && !src.startsWith('data:') && !src.startsWith('blob:');

  const fullPath = getFullUrlPath(configuration.storagePrefix, src);
  const resolvedSrc = needsPrefix ? fullPath : src;

  return resolvedSrc;
};
